An array of `JobCategory` identifiers.

Scheme requirements:

- The `seekAnz` scheme has a maximum of one element.
